import { Button } from "shared/ui/button";
import { useSidebar } from "shared/lib/hooks";
import { useMobile } from "shared/lib/hooks";
import { useActiveSection } from "shared/lib/hooks/useActiveSection";
import { HOME_ROUTE } from "shared/config/routes";
import { EventSidebar } from "..";
import { LoginSidebar } from "features";
import { EventRegistrationModal } from "features";
import { EventRegistrationButton } from "features";
import { useModal } from "shared/ui/modal";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import BurgerBtn from "shared/assets/images/Burger_btn.svg";
import Close from "shared/assets/images/Close.svg";
import Logo from "shared/assets/images/Logo.png";
import LogoSmall from "shared/assets/images/Logo_small.png";
import styles from "./EventHeader.module.scss";

export const EventHeader = () => {
  const {
    isCollapsed: isEventSidebarCollapsed,
    open: openEventSidebar,
    close: closeEventSidebar,
    toggleSidebar: toggleEventSidebar,
  } = useSidebar(true);

  const {
    isCollapsed: isLoginSidebarCollapsed,
    open: openLoginSidebar,
    close: closeLoginSidebar,
    toggle: toggleLoginSidebar,
  } = useSidebar(true);

  const {
    isModalOpen: isEventRegistrationModalOpen,
    open: openEventRegistrationModal,
    close: closeEventRegistrationModal,
    toggle: toggleEventRegistrationModal,
  } = useModal(false);

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  const isMobile = useMobile("1420px");

  const sectionIds = [
    "about",
    "experts",
    "partners",
    "program",
    "venue",
    "questions",
    "contacts",
  ];
  const activeSection = useActiveSection(sectionIds);

  const handleLinkClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      closeLoginSidebar();
    }
  };

  const handleBurgerClick = () => {
    if (isEventSidebarCollapsed && isLoginSidebarCollapsed) {
      openEventSidebar();
    } else {
      closeEventSidebar();
      closeLoginSidebar();
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          <div className={styles.headerMobileContainer}>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img
                    src={
                      isEventSidebarCollapsed && isLoginSidebarCollapsed
                        ? BurgerBtn
                        : Close
                    }
                    alt="burger btn"
                    height={26}
                  />
                }
                onClick={handleBurgerClick}
              />
            </div>
            <div className={styles.logo}>
              <a href={HOME_ROUTE}>
                <img
                  src={LogoSmall}
                  className={styles.logo__img}
                  alt="LogoSmall"
                />
              </a>
            </div>
          </div>
          <EventSidebar
            isCollapsed={isEventSidebarCollapsed}
            open={openEventSidebar}
            close={closeEventSidebar}
            toggleSidebar={toggleEventSidebar}
            loginSidebarOpen={openLoginSidebar}
          />
        </>
      ) : (
        <div className={styles.headerDesktopContainer}>
          <div className={styles.logo}>
            <a href="/">
              <img src={Logo} className={styles.logo__img} alt="Logo" />
            </a>
          </div>
          <div className={styles.centerBlock}>
            <div className={styles.links}>
              <a
                href="#about"
                className={`${styles.links__link} ${activeSection === "about" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("about");
                }}
              >
                О мероприятии
              </a>
              <a
                href="#experts"
                className={`${styles.links__link} ${activeSection === "experts" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("experts");
                }}
              >
                Эксперты
              </a>
              <a
                href="#partners"
                className={`${styles.links__link} ${activeSection === "partners" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("partners");
                }}
              >
                Партнеры
              </a>
              <a
                href="#program"
                className={`${styles.links__link} ${activeSection === "program" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("program");
                }}
              >
                Программа
              </a>
              <a
                href="#venue"
                className={`${styles.links__link} ${activeSection === "venue" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("venue");
                }}
              >
                Место проведения
              </a>
              <a
                href="#questions"
                className={`${styles.links__link} ${activeSection === "questions" ? styles.active : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("questions");
                }}
              >
                Вопросы
              </a>
              <a
                className={styles.links__linkDisabled}
                onClick={openDisabledElementModal}
              >
                Контакты
              </a>
            </div>
          </div>
          <div className={styles.buttonBlock}>
            <EventRegistrationButton
              variant="primary"
              openModal={openEventRegistrationModal}
            />
          </div>
        </div>
      )}
      <LoginSidebar
        isCollapsed={isLoginSidebarCollapsed}
        open={openLoginSidebar}
        close={closeLoginSidebar}
        toggle={toggleLoginSidebar}
        variant="eventPage"
      />
      <EventRegistrationModal
        isModalOpen={isEventRegistrationModalOpen}
        open={openEventRegistrationModal}
        close={closeEventRegistrationModal}
        toggle={toggleEventRegistrationModal}
      />
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
